import React from 'react';

interface MedicalCrossIconProps {
  fill?: string;
  className?: string;
}

export const MedicalCrossIcon: React.FC<MedicalCrossIconProps> = ({ fill = '#85ADAA', className = '' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="92" height="92" viewBox="0 0 92 92" fill="none" className={className}>
    <path
      d="M45.5479 0.5C56.3487 0.500194 65.1043 9.25589 65.1045 20.0566V20.5566H59.0605V20.0566C59.0604 12.5941 53.0105 6.54414 45.5479 6.54395C38.085 6.54395 32.0344 12.594 32.0342 20.0566V47.0332H25.9902V20.0566C25.9904 9.25577 34.7468 0.5 45.5479 0.5Z"
      fill={fill}
      stroke={fill}
    />
    <path
      d="M45.5479 90.5938C34.747 90.5936 25.9914 81.8379 25.9912 71.0371V70.5371H32.0352V71.0371C32.0354 78.4996 38.0852 84.5496 45.5479 84.5498C53.0107 84.5498 59.0613 78.4998 59.0615 71.0371V44.0605H65.1055V71.0371C65.1053 81.838 56.3489 90.5938 45.5479 90.5938Z"
      fill={fill}
      stroke={fill}
    />
    <path
      d="M0.5 45.5471C0.5 34.7461 9.25645 25.9895 20.0576 25.9895L20.5576 25.9895L20.5576 32.0334L20.0576 32.0334C12.5947 32.0334 6.54395 38.0843 6.54395 45.5471C6.54414 53.0098 12.5948 59.0598 20.0576 59.0598L47.0342 59.0598L47.0342 65.1038L20.0576 65.1038L19.5527 65.0969C8.98486 64.8293 0.500192 56.1793 0.5 45.5471Z"
      fill={fill}
      stroke={fill}
    />
    <path
      d="M90.5937 45.5466C90.5937 56.3477 81.8373 65.1042 71.0361 65.1042L70.5361 65.1042L70.5361 59.0603L71.0361 59.0603C78.4991 59.0603 84.5498 53.0094 84.5498 45.5466C84.5496 38.084 78.4989 32.0339 71.0361 32.0339L44.0596 32.0339L44.0596 25.99L71.0361 25.99L71.541 25.9968C82.1089 26.2644 90.5936 34.9144 90.5937 45.5466Z"
      fill={fill}
      stroke={fill}
    />
  </svg>
);
